  document.addEventListener("DOMContentLoaded", function() {
  if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick !== "undefined") {
    $('.gfa-content__grid-container').slick({
      slidesToShow: 9,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 4000,
      cssEase: 'linear',
      infinite: true,
      arrows: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024, // tablets
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 768, // mobile
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  } else {
    console.error("jQuery or Slick not loaded");
  }
});

/*
 document.addEventListener("DOMContentLoaded", function () {
    if (window.jQuery && $('.product-thumbnails div').length > 1) {
      $('.product-thumbnails').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-main-slider',
        focusOnSelect: true,
        vertical: true,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              vertical: false,
              slidesToShow: 3
            }
          }
        ]
      });

      $('.product-main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.product-thumbnails',
        adaptiveHeight: true
      });
    } else {
      $('.product-main-slider').slick({
        slidesToShow: 1,
        arrows: false
      });
    }
  });
*/


  document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion details');

    accordions.forEach((accordion) => {
      accordion.addEventListener('toggle', function () {
        if (accordion.open) {
          // Close all others
          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== accordion) {
              otherAccordion.removeAttribute('open');
            }
          });
        }
      });
    });
  });





  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.querySelector('.watch-video-btn');
    const modal = document.getElementById('videoModal');
    const iframe = document.getElementById('videoFrame');
    const closeBtn = document.querySelector('.video-close');

    if (btn) {
      btn.addEventListener('click', function () {
        let videoUrl = btn.getAttribute('data-video-url');

        // Convert short YouTube URL to embed format
        const urlObj = new URL(videoUrl);
        let videoId = urlObj.pathname.split('/')[1];
        let embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

        iframe.src = embedUrl;
        modal.style.display = 'flex';
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.style.display = 'none';
        iframe.src = '';
      });
    }

    window.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.style.display = 'none';
        iframe.src = '';
      }
    });
  });


window.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.tag-filters');

    if (!container) return; // stop if not found

    const button = container.querySelector('button[data-tag="automatic-machines"]');

    if (button) {
        container.appendChild(button);
    }
});

